export default {"src":"/_next/static/media/real_logo.2eb753cf.svg","height":286,"width":846,"blurWidth":0,"blurHeight":0};